import { render, staticRenderFns } from "./MentalAuth.vue?vue&type=template&id=13542c66&"
import script from "./MentalAuth.vue?vue&type=script&lang=js&"
export * from "./MentalAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports